import React from 'react'

import { IInputProps } from 'core-components/library/inputs'
import { VisualAudienceExtended } from 'core/components/shared/ui/VisualAudienceExtended'
import { OnboardingInput } from 'onboarding/components/ui/theme'

import styles from '../PartnerShipNA.module.scss'

import { IPartnerShipNA } from './types'

interface IProps {
  onChange: (field: string) => (value: string) => void
  item: IPartnerShipNA
  writeAudience: IObjectAny
  disabled?: boolean
}

export const SignatoryDetail = ({ onChange, item, writeAudience, disabled }: IProps) => {
  return (
    <div>
      <div className={styles.text__title}>
        Signatory Detail{' '}
        <div className={styles.text__rule}> (Applies only to Manual applications)</div>
      </div>
      <div className={styles.root}>
        <div className={styles.column__selling}>
          <VisualAudienceExtended<IInputProps>
            component={OnboardingInput}
            write={writeAudience}
            margin={'md'}
            label={'Signatory First name'}
            value={item.SignatoryFirstName || ''}
            onChange={onChange('SignatoryFirstName')}
            disabled={disabled}
          />

          <VisualAudienceExtended<IInputProps>
            component={OnboardingInput}
            write={writeAudience}
            margin={'md'}
            label={'Signatory Email'}
            value={item.SignatoryEmail || ''}
            onChange={onChange('SignatoryEmail')}
            disabled={disabled}
          />
        </div>
        <div className={styles.column__selling}>
          <VisualAudienceExtended<IInputProps>
            component={OnboardingInput}
            write={writeAudience}
            margin={'md'}
            label={'Signatory Last name'}
            value={item.SignatoryLastName || ''}
            onChange={onChange('SignatoryLastName')}
            disabled={disabled}
          />
          <VisualAudienceExtended<IInputProps>
            component={OnboardingInput}
            write={writeAudience}
            margin={'md'}
            label={'Job Function'}
            value={item.JobFunction || ''}
            onChange={onChange('JobFunction')}
            disabled={disabled}
          />
        </div>
      </div>
    </div>
  )
}
